/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */


/**
 * deletePicture is a flag which
 * says that user wants to delete picture
 * When such event is emmit - then flag becoming true
 * and backend deletes file and record in db
 */
export interface DeliveryMethod {
  id?: number;
  description?: string;
  header: string;
  enabled?: boolean;
  deleted?: boolean;
}
